export default __webpack_public_path__ + "1308645d7a2ef151ba3a8f8adc5c19b4.png";